var HeaderClass = (function () {
    function HeaderClass() {
    }
    return HeaderClass;
}());
//# sourceMappingURL=HeaderClass.js.map